import React, { memo } from 'react';
import type { FC } from 'react';

import resets from '../_resets.module.css';
import classes from './Group36.module.css';
import {Vector34Icon} from "./Vector34Icon";

interface Props {
  className?: string;
}
/* @figmaId 707:485 */
export const Group36: FC<Props> = memo(function Group36(props = {}) {
  return (
    <div className={`${resets.storybrainResets} ${classes.root}`}>
      <div className={classes.rectangle23}></div>
      <div className={classes.peakResults}>Peak Results</div>
      <div className={classes.vector34}>
        <Vector34Icon className={classes.icon} />
      </div>
      <div className={classes._2999}>$29.99</div>
      <div className={classes.monthlyRecurringPayment}>Monthly Recurring Payment</div>
      <div className={classes.aCCESSTOALLCLUBS}>ACCESS TO ALL CLUBS</div>
      <div className={classes.rectangle24}></div>
      <div className={classes.iNCLUDESCardioWeightsMachinesL}>
        <p className={classes.labelWrapper}>
          <span className={classes.label}>INCLUDES</span>
        </p>
        <p className={classes.labelWrapper2}></p>
        <div className={classes.textBlock}>Cardio, Weights &amp; Machines</div>
        <div className={classes.textBlock2}>Locker Rooms with Showers</div>
        <div className={classes.textBlock3}>Free Wi-Fi</div>
        <div className={classes.textBlock4}>CrunchONE Kickoff</div>
        <div className={classes.textBlock5}>Power Half Hour Circuit Training</div>
        <div className={classes.textBlock6}>Group Fitness Classes</div>
        <div className={classes.textBlock7}>Crunch Live Online Workouts</div>
        <div className={classes.textBlock8}>Free T-shirt</div>
        <div className={classes.textBlock9}>Ride Classes</div>
        <div className={classes.textBlock10}>HydroMassage®</div>
        <div className={classes.textBlock11}>Tanning</div>
        <div className={classes.textBlock12}>Guest Privileges</div>
        <div className={classes.textBlock13}>Advanced HIIT Classes</div>
        <div className={classes.textBlock14}>
          <p></p>
        </div>
        <div className={classes.textBlock15}>
          <p></p>
        </div>
        <div className={classes.textBlock16}>
          <p className={classes.labelWrapper3}>
            <span className={classes.label2}>AVAILABLE ADD-ONS</span>
          </p>
        </div>
        <div className={classes.textBlock17}>Personal Training</div>
      </div>
    </div>
  );
});
